import { render, staticRenderFns } from "./CreateBankAccountView.vue?vue&type=template&id=6769a2bc&"
import script from "./CreateBankAccountView.vue?vue&type=script&lang=ts&"
export * from "./CreateBankAccountView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports